/* ==============================================================================
   GULCAN PRODUCTS DRAG-TO-SCROLL
   ==============================================================================
   Adds desktop click-and-drag horizontal scrolling to product carousels
   (.gulcan-products-scroller). Mobile keeps its native touch-scroll behavior.

   The handler INTENTIONALLY ignores mousedowns that originate on a product
   image area (.gulcan-product-image-container). That zone has its own inner
   Swiper for the image gallery, so dragging there must move the gallery -
   never the outer carousel. Drags that start on the title, price, ratings,
   quick-add or any non-image part of the card scroll the outer carousel.

   After a real drag, click events on the just-dragged area are suppressed
   so users don't accidentally navigate into a product when releasing.
   ============================================================================== */

(function () {
  'use strict';

  // Pixels of horizontal movement before we count it as a real drag.
  // Below this, treat the gesture as a click.
  var DRAG_THRESHOLD = 5;

  // Selector for elements where dragging must NOT trigger outer scroll.
  // Anything inside the image area belongs to the inner image swiper.
  var IGNORE_DRAG_SELECTOR =
    '.gulcan-product-image-container, .gulcan-product-slider, .gulcan-product-image-link';

  function initScroller(scroller) {
    if (!scroller || scroller.dataset.dragInit === '1') return;
    scroller.dataset.dragInit = '1';

    var isPointerDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;

    function onMouseDown(e) {
      // Only respond to the primary mouse button. Ignore touch (let native scroll handle it).
      if (e.button !== 0 || e.pointerType === 'touch') return;

      // Bail out if the press started over an image area - inner swiper owns it.
      if (e.target.closest(IGNORE_DRAG_SELECTOR)) return;

      isPointerDown = true;
      didDrag = false;
      startX = e.clientX;
      startScrollLeft = scroller.scrollLeft;

      scroller.classList.add('is-grabbing');
    }

    function onMouseMove(e) {
      if (!isPointerDown) return;

      var dx = e.clientX - startX;

      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
      }

      if (didDrag) {
        // Swipe-forward direction: dragging right advances the carousel
        // (old items slide left out of view, new items enter from the right).
        // This matches the progress bar drag and the user's preferred mental
        // model -- "drag right = next" rather than "grab content and pull".
        scroller.scrollLeft = startScrollLeft + dx;
        // Prevent text selection / image dragging while we're scrolling.
        e.preventDefault();
      }
    }

    function endDrag() {
      if (!isPointerDown) return;
      isPointerDown = false;
      scroller.classList.remove('is-grabbing');
    }

    // If a real drag happened, swallow the next click so users don't
    // accidentally activate the link they were dragging on.
    function onClickCapture(e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }

    scroller.addEventListener('mousedown', onMouseDown);
    // Listen on document so a release outside the scroller still ends the drag.
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', endDrag);
    scroller.addEventListener('mouseleave', endDrag);
    scroller.addEventListener('click', onClickCapture, true);
  }

  function initAll(root) {
    var scope = root || document;
    var scrollers = scope.querySelectorAll('.gulcan-products-scroller');
    scrollers.forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when sections are reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
